import { render, staticRenderFns } from "./AdminAddUser.vue?vue&type=template&id=6d61c4d6&"
import script from "./AdminAddUser.vue?vue&type=script&lang=ts&"
export * from "./AdminAddUser.vue?vue&type=script&lang=ts&"
import style0 from "./AdminAddUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports